import Image from 'next/image';
import Link from 'next/link';
import cn from 'classnames';
import React from 'react';
import styles from './design-intro.module.css';

import laptop from '../../public/design/intro/laptop.png';
import с1 from '../../public/design/intro/1-min.png';
import с2 from '../../public/design/intro/2-min.png';
import с3 from '../../public/design/intro/3-min.png';
import с4 from '../../public/design/intro/4-min.png';
import с5 from '../../public/design/intro/5-min.png';
import { Button, Container, ContainerFluid, Paragraph } from '../../components';

export default function DesignIntro() {
  return (
    <div className={styles.root}>
      <ContainerFluid>
        <div className={styles.intro}>
          <Container>
            <div className={styles.wrapper}>
              <div className={styles.start}>
                <h1 className={styles.title}>DESIGN</h1>
                <Paragraph className={styles.subtitle}>
                  Get unique UX/UI design specifically for your project.
                </Paragraph>

                <div className={styles.laptop}>
                  <Image
                    alt="Laptop Keto Kitchen"
                    priority
                    src={laptop}
                    width={831}
                    height={446}
                  />
                </div>

                <Button
                  tag="a"
                  appearance="design"
                  href="#form"
                  className={styles.btn}
                >
                  Estimate design for my app
                </Button>
              </div>
              <div className={styles.end}>
                <div className={styles.row}>
                  <Link href="#sketching">
                    <div className={styles.circle}>
                      <div className={styles.leftangle}>
                        <Image
                          alt="dashed right angle"
                          priority
                          src="/design/r-angle@2x.png"
                          width={28}
                          height={125}
                        />
                      </div>
                      <span className={styles.counter}>1</span>
                      <Image
                        alt="Sketching"
                        priority
                        src={с1}
                        width={238}
                        height={238}
                      />
                      <div className={styles.line}>
                        <Image
                          alt="dashed line"
                          priority
                          src="/design/line@2x.png"
                          width={20}
                          height={1}
                        />
                      </div>
                    </div>
                  </Link>
                  <Link href="#wireframing">
                    <div className={styles.circle}>
                      <span className={styles.counter}>2</span>
                      <Image
                        alt="Wireframing"
                        priority
                        src={с2}
                        width={238}
                        height={238}
                      />
                      <div className={styles.rightangle}>
                        <Image
                          alt="dashed left angle"
                          priority
                          src="/design/l-angle@2x.png"
                          width={28}
                          height={125}
                        />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className={styles.row}>
                  <Link href="#illustrations">
                    <div className={styles.circle}>
                      <span className={styles.counter}>5</span>
                      <Image
                        alt="Illustrations"
                        priority
                        src={с5}
                        width={238}
                        height={238}
                      />
                      <div className={styles.line}>
                        <Image
                          alt="dashed second line"
                          priority
                          src="/design/line@2x.png"
                          width={20}
                          height={1}
                        />
                      </div>
                    </div>
                  </Link>
                  <Link href="#visual">
                    <div className={styles.circle}>
                      <span className={styles.counter}>4</span>
                      <Image
                        alt="Visual Design"
                        priority
                        src={с4}
                        width={238}
                        height={238}
                      />
                      <div className={styles.line}>
                        <Image
                          alt="dashed third line"
                          priority
                          src="/design/line@2x.png"
                          width={20}
                          height={1}
                        />
                      </div>
                    </div>
                  </Link>
                  <Link href="#brand">
                    <div className={styles.circle}>
                      <span className={styles.counter}>3</span>
                      <Image
                        alt="Brand Identity"
                        priority
                        src={с3}
                        width={238}
                        height={238}
                      />
                    </div>
                  </Link>
                </div>
                <h2 className={styles.text}>
                  The full design process in 5 stages
                </h2>
                <Button
                  tag="a"
                  appearance="design"
                  className={cn(styles.btn, styles.onlyMobile)}
                  href="#form"
                >
                  Estimate design for my app
                </Button>
              </div>
            </div>
          </Container>

          <div className={styles.box} />
        </div>
      </ContainerFluid>
    </div>
  );
}
